// Shared business data for AutoTech UK

export const BUSINESS = {
  name: "AutoTech UK",
  tagline: "Car Coding & Automotive Electronics",
  location: "London, E1",
  phone: "+44 7384 225380",
  phoneHref: "tel:+447384225380",
  whatsapp: "https://wa.me/447384225380",
  whatsappText:
    "https://wa.me/447384225380?text=Hi%20AutoTech%20UK%2C%20I%27d%20like%20a%20quote%20for...",
  instagramHandle: "@autotech.uk",
  instagram: "https://www.instagram.com/autotech.uk",
  yearsExperience: "6+",
  hours: "Mon–Sat · 09:00 – 19:00 · By appointment",
};

export const USPS = [
  "6+ Years Experience",
  "Fully Mobile Service",
  "Crypto Accepted",
  "Interest-Free Finance",
  "Fully Insured Workmanship",
  "Premium OEM & Non-OEM Parts",
  "London E1 & Surrounding Areas",
];

export const SERVICES = [
  {
    id: "carplay-coding",
    title: "Apple CarPlay & Android Auto Coding",
    desc: "Activate wireless CarPlay and Android Auto on factory head units through precision vehicle coding.",
    icon: "Smartphone",
    image: "https://customer-assets.emergentagent.com/job_auto-electric-pro/artifacts/ehr4gwdq_IMG_2982.jpeg",
    featured: true,
  },
  {
    id: "carplay-hardware",
    title: "CarPlay / Android Auto Hardware",
    desc: "Retrofit modules and interface boxes for older systems — full plug-and-play solutions.",
    icon: "Cable",
    image: "https://customer-assets.emergentagent.com/job_auto-electric-pro/artifacts/52h0p0md_IMG_2983.jpeg",
  },
  {
    id: "vehicle-coding",
    title: "Vehicle Coding & Customization",
    desc: "Unlock hidden features, personalise behaviour, and tune your car's software profile.",
    icon: "Cpu",
    image: "https://customer-assets.emergentagent.com/job_auto-electric-pro/artifacts/r9nxjzgo_IMG_2984.jpeg",
    featured: true,
  },
  {
    id: "mileage-blockers",
    title: "Mileage Blockers",
    desc: "Precision fitting of mileage stoppers — clean install, fully reversible.",
    icon: "Gauge",
    image: "https://customer-assets.emergentagent.com/job_auto-electric-pro/artifacts/bfs8kj3j_IMG_2986.jpeg",
  },
  {
    id: "trackers",
    title: "GPS Trackers (Live)",
    desc: "Thatcham-grade live GPS tracking with 24/7 monitoring and recovery support.",
    icon: "MapPin",
    image: "https://customer-assets.emergentagent.com/job_auto-electric-pro/artifacts/6ag450md_IMG_2987.jpeg",
    featured: true,
  },
  {
    id: "immobilisers",
    title: "Immobilisers",
    desc: "Ghost systems, OBD blockers and aftermarket immobilisers to defeat modern theft methods.",
    icon: "ShieldCheck",
    image: "https://customer-assets.emergentagent.com/job_auto-electric-pro/artifacts/6ag450md_IMG_2987.jpeg",
  },
  {
    id: "dashcams",
    title: "Dashcams",
    desc: "Front, rear and cabin dashcam installs — hardwired, hidden, evidence-ready. From £100 supply & fit.",
    icon: "Video",
    image: "https://customer-assets.emergentagent.com/job_auto-electric-pro/artifacts/36o761p4_AD0B7F61-302B-46C1-9168-63BF55444F9C.png",
  },
  {
    id: "fleet-dashcam",
    title: "Fleet Dashcam Live View 24/7",
    desc: "Live view with interior + exterior cam, GPS, two-way talk, cloud storage. £10/month — built for fleets and businesses.",
    icon: "MonitorPlay",
    image: "https://customer-assets.emergentagent.com/job_auto-electric-pro/artifacts/wpxn9gdu_D147B97A-F584-41C8-AE40-DAD866B63AD7.png",
  },
  {
    id: "screen-upgrades",
    title: "Screen Upgrades & Infotainment",
    desc: "Large-format replacement screens and Android-powered infotainment overhauls.",
    icon: "Tv",
    image: "https://customer-assets.emergentagent.com/job_auto-electric-pro/artifacts/fdiugc59_IMG_2988.png",
  },
  {
    id: "audio-upgrades",
    title: "Audio Upgrades & Sound Systems",
    desc: "Speakers, subs, amps and DSP tuning — engineered to match your cabin acoustics.",
    icon: "Speaker",
    image: "https://customer-assets.emergentagent.com/job_auto-electric-pro/artifacts/wv1fwfc7_IMG_2989.png",
  },
  {
    id: "ambient-starlights",
    title: "Ambient & Starlights",
    desc: "Fibre-optic starlight headliners and multi-zone ambient lighting systems.",
    icon: "Sparkles",
    image: "https://customer-assets.emergentagent.com/job_auto-electric-pro/artifacts/ojrkgjjg_IMG_2990.png",
    featured: true,
  },
  {
    id: "retrofits",
    title: "OEM & Non-OEM Retrofits",
    desc: "From comfort access and heated seats to premium sound — original-quality retrofits.",
    icon: "Wrench",
    image: "https://customer-assets.emergentagent.com/job_auto-electric-pro/artifacts/wqlsv3p5_IMG_2991.jpeg",
  },
  {
    id: "firestick",
    title: "Firestick Installation",
    desc: "Stream your favourite content on your factory screen, safely integrated.",
    icon: "Cast",
    image: "https://customer-assets.emergentagent.com/job_auto-electric-pro/artifacts/29mlc0hf_IMG_2993.jpeg",
  },
  {
    id: "digital-dash",
    title: "Digital Dash Upgrades",
    desc: "Swap analogue clusters for fully digital, customisable dashboards (selective cars).",
    icon: "LayoutDashboard",
    image: "https://customer-assets.emergentagent.com/job_auto-electric-pro/artifacts/ypzw22z2_IMG_3006.jpeg",
  },
  {
    id: "reverse-cameras",
    title: "Reverse Cameras & Parking",
    desc: "OEM reverse cameras for VW, Audi, Skoda, SEAT, Mercedes, Ford, BMW, MINI, Mazda + aftermarket solutions for any car, van, recovery truck or mini-bus.",
    icon: "Camera",
    image: "https://customer-assets.emergentagent.com/job_auto-electric-pro/artifacts/z02afvd6_0307981A-2EB0-47CD-B394-AA6AD0B8BE7C.png",
  },
  {
    id: "custom-wiring",
    title: "Custom Wiring Harness",
    desc: "Bespoke looms and clean wiring for retrofits, performance electronics and aftermarket kit.",
    icon: "Zap",
    image: "https://customer-assets.emergentagent.com/job_auto-electric-pro/artifacts/nfsmdnad_IMG_3007.jpeg",
  },
  {
    id: "custom-fuseboxes",
    title: "Custom Fuse Boxes",
    desc: "Workshop-grade auxiliary fuse boxes — clean, labelled, and built to last.",
    icon: "Plug",
    image: "https://customer-assets.emergentagent.com/job_auto-electric-pro/artifacts/p5q12b3z_IMG_3008.jpeg",
  },
  {
    id: "diagnostics",
    title: "Diagnostics & Repairs",
    desc: "Full multi-brand diagnostics, fault finding and electrical repairs.",
    icon: "Stethoscope",
    image: "https://customer-assets.emergentagent.com/job_auto-electric-pro/artifacts/m08juzrc_IMG_3009.jpeg",
  },
  {
    id: "jump-starts",
    title: "Jump Starts",
    desc: "Mobile jump starts for flat batteries — at home, on the roadside or at the office.",
    icon: "BatteryCharging",
    image: "https://customer-assets.emergentagent.com/job_auto-electric-pro/artifacts/38ybbvgx_IMG_3010.jpeg",
  },
  {
    id: "battery-replacements",
    title: "Battery Replacements",
    desc: "Supply and fit AGM, EFB and standard batteries with proper coding/registration.",
    icon: "Battery",
    image: "https://customer-assets.emergentagent.com/job_auto-electric-pro/artifacts/oj3mt72x_IMG_3011.jpeg",
  },
  {
    id: "leisure-batteries",
    title: "Leisure Batteries",
    desc: "Auxiliary leisure battery installs for camper conversions, vans and overlanders.",
    icon: "BatteryFull",
    image: "https://customer-assets.emergentagent.com/job_auto-electric-pro/artifacts/8mnvc81e_IMG_3012.jpeg",
  },
  {
    id: "inverter-installs",
    title: "Inverter Installs",
    desc: "Pure-sine inverter installs to power tools, fridges and laptops from your vehicle.",
    icon: "Power",
    image: "https://customer-assets.emergentagent.com/job_auto-electric-pro/artifacts/1lwen3aa_IMG_3013.jpeg",
  },
];

export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/c25e8aeb-69ab-4dd6-8093-f41575ca1ae3/images/2caf4803de6ce6514d1ec98504febbf78a9d2e8ef9fef15e211e2ff3ff91bb50.png",
  ambient:
    "https://images.unsplash.com/photo-1773696888016-1cc2757b0693?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxjYXIlMjBhbWJpZW50JTIwbGlnaHRpbmclMjBpbnRlcmlvcnxlbnwwfHx8fDE3Nzc1NDAxNTF8MA&ixlib=rb-4.1.0&q=85",
  coding:
    "https://static.prod-images.emergentagent.com/jobs/c25e8aeb-69ab-4dd6-8093-f41575ca1ae3/images/c45c1499e47d9dc5c02128f0f9ea520f3acaa9d7a49d5a71129380d620eb2357.png",
  exterior:
    "https://static.prod-images.emergentagent.com/jobs/c25e8aeb-69ab-4dd6-8093-f41575ca1ae3/images/aefdaefd8949c2208d948ab4d72f17fb0ed69da882f939f0c26065d2b7cb183c.png",
  dashboard:
    "https://images.unsplash.com/photo-1758411897888-3ca658535fdf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBjYXIlMjBpbnRlcmlvciUyMGRhc2hib2FyZCUyMGRpc3BsYXl8ZW58MHx8fHwxNzc3NTQwMTUxfDA&ixlib=rb-4.1.0&q=85",
  dashClose:
    "https://images.pexels.com/photos/9792971/pexels-photo-9792971.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

// Instagram posts to embed in the showcase (newest first).
// type is "p" (post) or "reel". shortcode is the segment after /p/ or /reel/.
export const INSTAGRAM_POSTS = [
  { type: "p", shortcode: "DOja2Q4DRVr" },
  { type: "p", shortcode: "DOyp5ozDfck" },
  { type: "p", shortcode: "DOflh0uDR4r" },
  { type: "p", shortcode: "DWCfLirDdc4" },
  { type: "p", shortcode: "DVjm6IbjcVM" },
  { type: "p", shortcode: "DVhOvmxDZf3" },
  { type: "p", shortcode: "DVb24ILjfu_" },
  { type: "p", shortcode: "DVYeDw7jT9G" },
  { type: "p", shortcode: "DSPoPIHjaxn" },
  { type: "reel", shortcode: "DRdBxxfjWXr" },
  { type: "p", shortcode: "DQ1rG8FDalo" },
  { type: "p", shortcode: "DQzli4MDbt6" },
  { type: "p", shortcode: "DQb2CwYjSMm" },
  { type: "p", shortcode: "DQMnR-JDexj" },
  { type: "p", shortcode: "DPmBqbWjdMF" },
  { type: "p", shortcode: "DPmBhEGDWHB" },
  { type: "p", shortcode: "DPEISqGjSnH" },
  { type: "p", shortcode: "DPBP0mbje4L" },
  { type: "p", shortcode: "DO9mphKiGcF" },
  { type: "p", shortcode: "DOoRe9FDTCU" },
  { type: "p", shortcode: "DOlUzF4jUO8" },
  { type: "p", shortcode: "DOgYgu4jSA6" },
  { type: "p", shortcode: "DOekuh0jWsF" },
  { type: "p", shortcode: "DN0dZiOWkZZ" },
  { type: "p", shortcode: "DNsmGCfWvUo" },
  { type: "p", shortcode: "DNY94m1tcL3" },
  { type: "p", shortcode: "DLgDKIRtg-B" },
  { type: "p", shortcode: "DLQJZPmtKt4" },
  { type: "p", shortcode: "DKw4ZMLNBcf" },
];

export const TESTIMONIALS = [
  {
    name: "Daniel R.",
    car: "BMW M340i",
    text: "Had wireless CarPlay and ambient lighting done on my M340i. The attention to detail is insane — couldn't tell anything was aftermarket. Top bloke, came to my office.",
  },
  {
    name: "Aisha K.",
    car: "Audi Q5",
    text: "Digital dash upgrade and a ghost immobiliser fitted in one visit. Clean install, proper explanation, and they even took crypto. Would 100% recommend.",
  },
  {
    name: "Marcus T.",
    car: "Mercedes C-Class",
    text: "Starlight headliner fitted at home over a weekend. Looks like factory OEM. Price was unbeatable and the finance option made it a no-brainer.",
  },
  {
    name: "Leon P.",
    car: "Range Rover Sport",
    text: "Four shops refused the retrofit I wanted. AutoTech UK got it done in a day. Real experts — not just fitters.",
  },
];
